import React from "react"
import TableOfContents from "./TableOfContents"
import PostSharing from "./PostSharing"

type Props = {
  html: string
  post: any
  custom_template: string
}

const StickyMenu: React.FC<Props> = ({ html, post, custom_template }) => {
  return (
    <div className="hidden xl:block absolute top-0 left-full h-full pl-6 w-80">
      <div className="sticky top-15 text-neutral-800 text-sm font-medium">
        {custom_template === "custom-post-with-toc" && (
          <TableOfContents html={html} />
        )}
        <PostSharing post={post} />
      </div>
    </div>
  )
}

export default StickyMenu
